import React, { useState } from 'react';
import * as moment from 'moment-timezone';
import NumberInput from 'web/components/form-elements/NumberInput';
import TextArea from 'web/components/form-elements/TextArea';
import Button from 'web/components/Button';
import EditIcon from "web/assets/svg/EditUnderlineIcon";
import { Table } from 'reactstrap';
import { Heading, TableWrapper } from 'web/pages/private/Admin/adminStyled'
import { Formik } from 'formik';
import { setInitialValuesGlobalFee, GLOBAL_FEE_VALIDATION_SCHEMA } from './utils'
import { GloablFeeWrapperWrapper, GlobalTermsFeeTableWrapper } from './SupplierFeeManagementStyles'
import { globalTermsListTableHeader } from './SupplierConstants'
import TooltipMaterial from "@material-ui/core/Tooltip";
import CommentIcon from 'web/assets/svg/CommentIcon'

function GlobalFeeVariableTab({ pageData, updateFee }) {
  const [editMode, setEditMode] = useState(false);

  const handleSave = (props) => {
    setEditMode(false);
    updateFee(props.values);
  };

  return (
    <GloablFeeWrapperWrapper>
      <Formik
        enableReinitialize={true}
        initialValues={setInitialValuesGlobalFee(pageData)}
        validationSchema={GLOBAL_FEE_VALIDATION_SCHEMA}
        onSubmit={_ => { }}>
        {(props) => {
          const { setFieldValue, isValid, dirty, values } = props;
          return (
            <div>
              <div className="global-fee-section">
                <div className='instructions'>
                  The following figures reflect the universal fees for pallettrader.com’s transactional marketplace and for loads transacted through PT+ managed business.
                  <span onClick={() => setEditMode(true)}><EditIcon /></span>
                </div>
                <h3 className="global-fee-section-title">PalletTrader.com Marketplace</h3>
                <div className="fee-wrapper">
                  <div className="form-field">
                    <label className="form-label">
                      Seller Fee
                    </label>
                    <div className='form-value'>
                      <NumberInput name="sellerFee" placeholder='0.0' disabled={!editMode} fieldType="percentage" maxAllowedValueLimit={100} decimalLimit={1} />%
                    </div>
                  </div>
                  <div className="form-field">
                    <label className="form-label">
                      Buyer Fee
                    </label>
                    <div className='form-value'>
                      <NumberInput name="buyerFee" placeholder='0.0' disabled={!editMode} fieldType="percentage" maxAllowedValueLimit={100} decimalLimit={1} />%
                    </div>
                  </div>
                  <div className="form-field">
                    <label className="form-label">
                      Broker Fee
                    </label>
                    <div className='form-value'>
                      <NumberInput name="brokerFee" placeholder='0.0' disabled={!editMode} fieldType="percentage" maxAllowedValueLimit={100} decimalLimit={1} />%
                    </div>
                  </div>
                </div>
              </div>

              <div className="global-fee-section">
                <h3 className="global-fee-section-title">
                  PT+ Managed Business on PT.com
                </h3>
                <div className="fee-wrapper">
                  <div className="form-field">
                    <label className="form-label">
                      Seller Fee (deliveries)
                    </label>
                    <div className='form-value'>
                      <NumberInput name="ptPlusSellerFee" placeholder='0.0' disabled={!editMode} fieldType="percentage" maxAllowedValueLimit={100} decimalLimit={1} />%
                    </div>
                  </div>
                  <div className="form-field">
                    <label className="form-label">
                      Buyer Fee (pickups)
                    </label>
                    <div className='form-value'>
                      <NumberInput name="ptPlusBuyerFee" placeholder='0.0' disabled={!editMode} fieldType="percentage" maxAllowedValueLimit={100} decimalLimit={1} />%
                    </div>
                  </div>
                </div>
              </div>

              <div className="global-fee-section">
                <h3 className="global-fee-section-title">
                  Global System Supplier Terms for PT+ Managed Business
                </h3>
                <div className="fee-wrapper">
                  <div className="form-field">
                    <label className="form-label">
                      Deliveries
                    </label>
                    <div className='form-value'>
                      <NumberInput name="supplierTermDelivery" placeholder='0' disabled={!editMode} maxAllowedValueLimit={999} fieldType="percentage" decimalLimit={0} />days
                    </div>
                  </div>
                  <div className="form-field">
                    <label className="form-label">
                      Pickups
                    </label>
                    <div className='form-value'>
                      <NumberInput name="supplierTermPickup" placeholder='0' disabled={!editMode} maxAllowedValueLimit={999} fieldType="percentage" decimalLimit={0} />days
                    </div>
                  </div>
                </div>
              </div>

              <div className="form-field comments-styling">
                <label className="form-label">
                  Comments
                </label>
                <div className='form-value-text-area'>
                  <TextArea
                    name="comments"
                    inputType="textAndNumber"
                    disabled={!editMode}
                    maxLength='500'
                  />
                </div>
              </div>

              <div className="form-field">
                <label className="form-label">
                  Date/time stamp of update
                </label>
                <div className='form-value'>
                  {pageData?.feeDateTime ? moment.utc(pageData?.feeDateTime).tz("America/New_York").format("MM/DD/YYYY, hh:mm A") : 'NA'}
                </div>
              </div>

              <div className="button-group">
                <Button
                  type="app-green-button submitBtn"
                  disabled={!(isValid && dirty)}
                  handleClick={() => {
                    handleSave(props)
                  }}
                >
                  Save Global Fee
                </Button>
              </div>
            </div>
          );
        }}
      </Formik>
      <GlobalTermsFeeTableWrapper>
        <TableWrapper>
          <Heading style={{ minHeight: '40px' }}>
            <h3 style={{ fontSize: '16px' }}>Logs Summary</h3>
          </Heading>
          <Table responsive>
            <thead>
              <tr>
                {globalTermsListTableHeader.map((items, index) => (
                  <th key={index}>{items.title}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {
                pageData?.feeHistories?.map((items, index) => (
                  <tr key={index}>
                    <td className='date-time'>
                      {items?.createdAt
                        ? moment.utc(items.createdAt).tz("America/New_York").format("MM/DD/YYYY, hh:mm A")
                        : "NA"}
                    </td>
                    <td>{items?.sellerFee?.toFixed(1) || 0.0} %</td>
                    <td>{items?.buyerFee?.toFixed(1) || 0.0} %</td>
                    <td>{items?.brokerFee?.toFixed(1) || 0.0} %</td>
                    <td>{items?.ptPlusSellerFee?.toFixed(1) || 0.0} %</td>
                    <td>{items?.ptPlusBuyerFee?.toFixed(1) || 0.0} %</td>
                    <td>{items?.supplierTermDelivery} days</td>
                    <td>{items?.supplierTermPickup} days</td>
                    <td>
                      {items.comments?.trim() ?
                        <TooltipMaterial
                          placement="top"
                          arrow
                          title={items?.comments?.trim()}
                          enterTouchDelay={0}
                        >
                          <span className="comments"><CommentIcon /></span>
                        </TooltipMaterial>
                        :
                        <span className="comments">NA</span>
                      }
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </TableWrapper>
      </GlobalTermsFeeTableWrapper >
    </GloablFeeWrapperWrapper>
  )
}

export default GlobalFeeVariableTab